import * as Sentry from '@sentry/react';

import { appEnv } from '@/app/shared/constants/env';

if (!appEnv) {
  throw new Error('VITE_APP_ENV is not defined');
}

Sentry.init({
  dsn: 'https://6bd19bf3bb3b43421b09383dd25bde45@o4510551689461760.ingest.de.sentry.io/4510551691952208',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: appEnv,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});